<template>
  <div class="row main-content">
    <SocialBar/>
    <NosotrosComponent/>
  </div>
</template>

<script>
import NosotrosComponent from './components/NosotrosComponent.vue';
import SocialBar from './components/SocialBar.vue';


export default {
  name: 'Nosotros',
  components: {
    SocialBar,
    NosotrosComponent
  }
}

</script>